import axios, { AxiosResponse } from 'axios'
import jwt from 'jsonwebtoken'
import { DateTime } from 'services/database/reportsDatabase'
import {
  PerfilUsuario,
  Fornecedor,
  Contrato,
  Usuario,
  UsuarioFornecedor,
  ResponseGeneric,
  LoginUsuario,
  ProfileCreatedUser
} from 'utils/types'

import {
  RequestCDU,
  RequestREAD,
  RequestGENERIC,
  RequestLOGINSSO
} from '../Instances'
import { IGenericEntityResponse } from 'services/core/entityResponseCore'

export const UserContractServices = () => {
  const path = 'ContratoUsuFornecedor'
  const create = async (
    requestObj: ContratoUsuarioRequest[]
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/inserirContratoUsuFornecedor`, requestObj)

  const del = async (requestObj: number[]): Promise<AxiosResponse> =>
    await RequestCDU.delete(`${path}/deletarContratoUsuFornecedor`, {
      data: {
        listaIdsContratoUsuFornecedor: requestObj
      }
    })

  const getContratosUsuario = async (
    // @:TROCA idFornecedor?: number,
    id?: number,
    removerUsuario: Boolean = false,
    idUsuarioLogado?: number
  ): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/BuscarContratosPorUsuarioFornecedor`, {
      params: {
        id,
        idPai: idUsuarioLogado,
        isVinculado: removerUsuario
        // @:TROCA idFornecedor,
      }
    })

  const getContratos = async (idFornecedor?: number): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/BuscarContratosPorFornecedor`, {
      params: {
        idFornecedor
      }
    })

  return { create, del, getContratos, getContratosUsuario }
}

export const ContractUserSupplierServices = () => {
  const path = 'ContratoFornecedor'
  const get = async (id: number): Promise<AxiosResponse<Contrato[]>> =>
    await RequestREAD.get(`${path}/${id}`)
  return { get }
}

export const FornecedorServices = () => {
  const path = 'Fornecedor'

  const supplierEmailValidation = async (
    requestObj: ValidacaoEmailFornecedor
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/DisparoEmailPrimeiroAcesso`, requestObj)

  return { supplierEmailValidation }
}

export const UserServices = () => {
  const path = 'Usuario'

  const updateProfile = async (
    usuarioId: number,
    perfilId: number
  ): Promise<AxiosResponse<IGenericEntityResponse<ProfileCreatedUser[]>>> =>
    await RequestCDU.post(`${path}/AtualizarPerfilUsuario`, {
      usuarioId,
      perfilUsuarioId: perfilId
    })

  const create = async (requestObj: Usuario): Promise<AxiosResponse> =>
    await RequestGENERIC.post('criarUsuario', requestObj)

  const patch = async (requestObj: Usuario): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/atualizarUsuario`, requestObj)

  const getAll = async (): Promise<AxiosResponse<Usuario[]>> =>
    await RequestREAD.get(path)

  const put = async (requestObj: Usuario[]): Promise<AxiosResponse> =>
    await RequestCDU.put(`${path}/UpdateUsuario`, requestObj)

  const changePassword = async (
    requestObj: RequestChangePassword
  ): Promise<AxiosResponse<ResponseChangePassword>> =>
    await RequestGENERIC.post(`passwordRecovery`, requestObj)

  const validate = async (
    requestObj: RequestValidarAcesso
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/ValidarAcesso`, requestObj)

  const validateFirstAcess = async (
    requestObj: RequestValidateFirstAcess
  ): Promise<AxiosResponse> =>
    await RequestGENERIC.post('ValidarDesafioIdentidadeFornecedor', requestObj)

  const refreshToken = async (
    requestObj: IRefreshToken
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/refreshToken`, requestObj)

  const login = async (
    requestObj: LoginUsuario
  ): Promise<AxiosResponse<ResponseLogin>> =>
    await RequestGENERIC.post(`Authorize`, requestObj)

  const logout = async (
    requestObj: LogOutUser
  ): Promise<AxiosResponse<ResponseLogOut>> => {
    const token = localStorage.getItem('csn-tk');
    const tokenDescrited = jwt.decode(token)
    return await RequestCDU.post(
      `${path}/Logout`,
      requestObj,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
  };


  const easterEGGLogin = async (): Promise<AxiosResponse<ResponseLogin>> =>
    await RequestGENERIC.post('EasterEGGLogin')

  const loginAccess = async (
    requestObj: LoginUsuario
  ): Promise<AxiosResponse<ResponseLogin>> =>
    await RequestCDU.post(`${path}/login`, requestObj)

  const requestNewPassword = async (
    requestObj: RequestNewPassword
  ): Promise<AxiosResponse<ResponseGeneric>> =>
    await RequestGENERIC.post('/DisparoEmailRecuperacaoSenha', requestObj)

  const verificarUsuarioExistente = async (
    requestObj: VerificarUsuario
  ): Promise<AxiosResponse<ResponseVerificarUsuario>> =>
    await RequestCDU.post(path + '/VerificarUsuarioExistente', requestObj)

  const updateFlSituacao = async (
    body: IUpdateFlSituacaoBody
  ): Promise<AxiosResponse<IUpdateFlSituacaoResponse>> =>
    await RequestCDU.post(`${path}/ModificarSituacaoUsuario`, body)

  const buscarUsuarioPorEmail = async (
    email: string
  ): Promise<AxiosResponse<BuscarUsuarioPorEmailResponse>> =>
    await RequestGENERIC.get(`BuscarPorUsuario/${email}`)

  const buscarUsuarioPorID = async (
    id: number
  ): Promise<AxiosResponse<BuscarUsuarioPorIdResponse>> =>
    await RequestREAD.get(`Usuario/${id}`)

  const getCredentials = async () =>
    await RequestGENERIC.post(`/GetCredentials`, null, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      withCredentials: true
    })

  const getSSOCredentials = async () =>
    await RequestLOGINSSO.post(`/Usuario/GetCredentials`, null, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      withCredentials: true
    })

  const updateRamal = async (
    request_body: IUpdateRamal[]
  ): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/atualizaRamal`, request_body)

  return {
    buscarUsuarioPorEmail,
    changePassword,
    create,
    easterEGGLogin,
    getAll,
    getCredentials,
    getSSOCredentials,
    login,
    loginAccess,
    patch,
    put,
    refreshToken,
    updateProfile,
    requestNewPassword,
    updateFlSituacao,
    updateRamal,
    validate,
    validateFirstAcess,
    verificarUsuarioExistente,
    buscarUsuarioPorID,
    logout
  }
}

export interface BuscarUsuarioPorIdResponse {
  cdDocto: string;
  idUsuario: number;
  nmUsuario: string;
  nuContato: string;
  txEmail: string;
}

export interface LogOutUser {
  idUsuario: number
}

export interface IUpdateRamal {
  idUsuario: number
  nuRamal: string
}

export interface BuscarUsuarioPorEmailResponse {
  idUsuario: number
  nmUsuario: string
  txEmail: string
  cdDocto: string
  nuContato: string
  nuRamal: string
  perfilUsuarioId: number
  perfilUsuario?: any
  tCarteiraAnalista: any[]
  tContraparteSubstitutos: any[]
  tContratoCompradorUsuarios: any[]
  tContratoContraparteUsuarios: any[]
  tContratoUsuFornecedors: any[]
  tUsuarioCsns: any[]
  tUsuarioFornecedors: any[]
}

export const profileCreatedUserService = () => {
  const path = 'PerfilCadastroUsuario'

  const getAll = async (
    id: number
  ): Promise<AxiosResponse<ProfileCreatedUser[]>> =>
    await RequestREAD.get(`${path}?IdUsuario=${id}`)

  return { getAll }
}

export const UserSupplierServices = () => {
  const path = 'UsuarioFornecedor'

  const del = async (id: number): Promise<AxiosResponse> =>
    await RequestCDU.delete(`${path}/Delete?id=${id}`)

  const getAll = async (
    params: ISupplierGetAllParams
  ): Promise<AxiosResponse<UserSupplierGetAllResponse>> =>
    await RequestREAD.get(path, { params })
  // PEGA TODOS USUARIO DO FORNECEDOR
  const getUsersSupplier = async (
    id: number
  ): Promise<AxiosResponse<UsuarioFornecedor[]>> =>
    await RequestREAD.get(`${path}/Fornecedor/${id}`)

  const getByEmail = async (email: string, token: string): Promise<AxiosResponse<UsuarioFornecedor>> => {
    const params = new URLSearchParams({
      email,
      token
    });

    return await RequestGENERIC.get(`BuscarUsuarioFornecedor?${params}`);
  }

  // PEGA UM USUARIOFORNECEDOR ( BACK INCOMPLETO)
  const get = async (id: number): Promise<AxiosResponse<UsuarioFornecedor>> =>
    await RequestREAD.get(`${path}/${id}`)
  const patch = async (
    requestObj: RequestNovoUsuarioFornecedor
  ): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/Update`, requestObj)

  return { del, get, getAll, getByEmail, getUsersSupplier, patch }
}

export const ProfileUserServices = () => {
  const path = 'PerfilUsuario'

  const create = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/Create`, requestObj)

  const del = async (id: number): Promise<AxiosResponse> =>
    await RequestCDU.delete(`${path}/Delete?id=${id}`)

  const get = async (
    id?: number,
    tipo?: string
  ): Promise<AxiosResponse<PerfilUsuario[]>> =>
    id
      ? await RequestREAD.get(`${path}/${id}`)
      : await RequestREAD.get(`${path}${tipo ? `?tipo=${tipo}` : ''}`)

  const getSuppliers = async (
    id?: number
  ): Promise<AxiosResponse<PerfilUsuario[]>> =>
    id
      ? await RequestREAD.get(`${path}/${id}`)
      : await RequestGENERIC.get('BuscarRolesFornecedor')

  const patch = async (): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/Update`)

  return { create, del, get, getSuppliers, patch }
}

export const UserCsnService = () => {
  const path = 'UsuarioCsn'
  const getAll = async (): Promise<AxiosResponse<any>> =>
    await RequestREAD.get(path)

  const getByNome = async (
    nome: string,
    likeSearch: Boolean = false,
    analystOrNormative: Boolean = false
  ): Promise<AxiosResponse<IGetCsnUserByResponse[]>> =>
    await RequestREAD.get(
      `${path}/Nome?nome=${nome}&likeSearch=${likeSearch}&analystOrNormative=${analystOrNormative}`
    )

  const getByMatricula = async (
    matricula: string,
    likeSearch: Boolean = false
  ): Promise<AxiosResponse<IGetCsnUserByResponse[]>> =>
    await RequestREAD.get(`${path}/Matricula?matricula=${matricula}`)

  const autoComplete = async (
    params: IAutoCompleteParams
  ): Promise<AxiosResponse<IAutoCompleteResponse>> =>
    await RequestREAD.get(`${path}/Autocomplete`, { params })

  return { autoComplete, getAll, getByMatricula, getByNome }
}

export interface ISupplierGetAllParams {
  CPFCNPJPASSAPORT?: string
  IsGST?: boolean
  NmFornecedor?: string
  CPFPASSAPORTE?: string
  NmColaborador?: string
  ValidadeAcessoInicio?: string
  ValidadeAcessoFim?: string
  Status?: string
  txEmail?: string
  PageNumber: number
  PageSize: number
}

export interface IUpdateFlSituacaoBody {
  idUsuario: number
  flSituacao: string
  perfilUsuarioId?: number
}

export interface IUpdateFlSituacaoResponse {
  sucesso: boolean
  mensagem: string
  detalhe?: any
  tipo?: any
}

export interface VerificarUsuario {
  cdDocto: string
  email: string
  nuContato: string
}

export interface ResponseVerificarUsuario {
  usuarioExistente: boolean
  sucesso: boolean
  title?: string
  mensagem: string
  detalhe: string
  tipo: string
  idUsuario: number
}
export interface RequestNewPassword {
  url: string
  email: string
}
export interface RequestValidateFirstAcess {
  contratoId: number
  respostaDesafio: string
  emailUsuario: string
  url: string
}
export interface RequestNovoUsuarioFornecedor {
  fornecedorId?: number
  cdDocto?: string
  flSituacao?: string
  dtSituacao?: Date
  dtValidade?: Date
  dtRevalidacaoSenha?: Date
  flPrimeiroAcesso?: boolean
  usuarioId?: number
  externalUsuarioId?: string
  idUsuarioFornecedor?: number
  fornecedor?: Fornecedor
  usuario?: Usuario
}

export interface ResponseRefreshToken {
  result: {
    title: string
    status: number
    detail: string
  }
  id: number
  exception: any
  status: number
  isCanceled: boolean
  isCompleted: true
  isCompletedSuccessfully: boolean
  creationOptions: number
  asyncState: any
  isFaulted: boolean
}

export interface RequestNovoUsuario {
  nmUsuario: string
  txEmail: string
  nuContato: string
  nuRamal?: string
  externalUsuarioId?: string
  fornecedorId: number
  perfilUsuarioId: number
}

export interface RequestContratoUsuario {
  contratoUsuFornecedorList: ContratoUsuarioRequest[]
}

export interface ContratoUsuarioRequest {
  idUsuario: number
  idContrato: number
  idContratoUsuFornecedor: number
  ativo?: boolean
}

export interface ValidacaoEmailFornecedor {
  idContrato: number
  cdContrato?: string
  url: string
}

export interface RequestChangePassword {
  email: string
  newPassword: string
  token?: string
  currentPassword?: string
}

export interface ResponseChangePassword {
  identityResult: any
  sucesso: boolean
  mensagem: string
  detalhe: string
  tipo: string
}

export interface RequestValidarAcesso {
  urlRedirecionamento: string
  listaIdsAprovacao: number[]
  flSituacao: string
  nomeAnalista: string
}

export interface IPasswordRecovery {
  email: string
  newPassword: string
}
export interface IRefreshToken {
  email: string
  refreshToken: string
  token?: string
  role?: string
  perfilUsuarioId?: string
}

export interface ResponseLogOut {
  sucesso: boolean
  mensagem?: string
}
export interface ResponseLogin {
  name?: any
  token: string
  refreshToken?: string
  flStatus?: string
  sucesso: boolean
  mensagem?: string
  detalhe?: string
  tipo?: string
}

export interface ICsnUserGotBy {
  idUsuario: number
  nmUsuario: string
  txEmail: string
  cdDocto: string
  nuContato: string
  nuRamal: string
  perfilUsuarioId: number
  perfilUsuario: any | null
  tCarteiraAnalista: any[]
  tContraparteSubstitutos: any[]
  tContratoCompradorUsuarios: any[]
  tContratoContraparteUsuarios: any[]
  tContratoUsuFornecedors: any[]
  tUsuarioCsns: any[]
  tUsuarioFornecedors: []
}

export interface IGetCsnUserByResponse {
  informacoes: string
  idUsuarioCsn: number
  usuarioId: number
  nmMatricula: string
  cargo: string
  idUnidGestora: number
  unidGestora: null | any
  usuario: ICsnUserGotBy
}

export interface IAutoCompleteParams {
  nmUsuario?: string | null
  cdMatricula?: string | null
  hasLikeSearch?: boolean
  isNGT?: boolean
}

interface IAutoCompleteEntity {
  idUsuario: number
  nmUsuario: string
  idUsuarioCsn: number
  cdMatricula: string
}

export interface IAutoCompleteResponse {
  entity: IAutoCompleteEntity[]
  sucesso: boolean
  mensagem: any | null
  detalhe: any | null
  tipo: any | null
}

export interface FornecedorGetAll {
  idFornecedor: number
  cdFornecedor: number
  cdFornecedorSap: string
  cdTipoFornecedor: string
  cdDocto: string
  nmFornecedor: string
  cdCep: string
  txEndereco: string
  nuNumero: string
  txComplemento: string
  txBairro: string
  sgPais: string
  sgEstado: string
  txCidade: string
  nuTelefone: string
  nuCelular: string
  nmResponsavel: string
  cdCpfResponsavel: string
  txEmailResponsavel: string
  nuCelResponsavel: string
  flSap: boolean
  dtPrimeiroAcesso: Date
  tContratos: any[]
  tEfetivoLogicos: any[]
  tFornecedorContatos: any[]
  tFornecedorSindicatos: any[]
  tMovEfetivos: any[]
  tUsuarioFornecedors: any[]
  tAcordoConvencao: any[]
}

export interface PerfilUsuarioGetAll {
  idPerfilUsuario: number
  cdTipo: string
  txDenominacao: string
  cdAlias: string
  tUsuarios: any[]
}

export interface UsuarioGetAll {
  idUsuario?: number
  nmUsuario?: string
  txEmail?: string
  cdDocto?: string
  nuContato?: string
  nuRamal?: string
  perfilUsuarioId?: number
  perfilUsuario?: PerfilUsuarioGetAll
  tCarteiraAnalista?: any[]
  tContraparteSubstitutos?: any[]
  tContratoCompradorUsuarios?: any[]
  tContratoContraparteUsuarios?: any[]
  tContratoUsuFornecedors?: any[]
  tUsuarioCsns?: any[]
  tUsuarioFornecedors?: any[]
}

export interface Item {
  fornecedorId: number
  flSituacao: string
  dtSituacao: Date
  dtValidade: Date
  dtRevalidacaoSenha: Date
  flPrimeiroAcesso: boolean
  usuarioId: number
  externalUsuarioId: string
  idUsuarioFornecedor: number
  fornecedor: FornecedorGetAll
  usuario: UsuarioGetAll
}

export interface UserSupplierGetAllResponse {
  pageCount: number
  totalItemCount: number
  pageNumber: number
  pageSize: number
  hasPreviousPage: boolean
  hasNextPage: boolean
  isFirstPage: boolean
  isLastPage: boolean
  firstItemOnPage: number
  lastItemOnPage: number
  items: Item[]
}
